import React from "react";
import { useGetProjectsQuery } from "../../features/Projects/ProjectsApi";
import ProjectsList from "./ProjectsList";
import Team from "./Team/Team";

const Sidebar = () => {
  const { data: projects, isError, isLoading } = useGetProjectsQuery();

  // decide what to render
  let content = null;

  if (isLoading) {
    content = <li className="m-2 text-center">Loading...</li>;
  } else if (!isLoading && isError) {
    content = <li className="m-2 text-center">There was an error.</li>;
  } else if (!isLoading && !isError && projects?.length === 0) {
    content = <li className="m-2 text-center">No conversations found!</li>;
  } else if (!isLoading && !isError && projects?.length > 0) {
    content = projects.map((project) => (
      <ProjectsList key={project.id} project={project}></ProjectsList>
    ));
  }

  return (
    <div className="sidebar">
      {/* <!-- Projects List --> */}
      <div>
        <h3 className="text-xl font-bold">Projects</h3>
        <div className="mt-3 space-y-4">{content}</div>
      </div>

      {/* <!-- Team Members --> */}
      <Team></Team>
    </div>
  );
};

export default Sidebar;
